jQuery(document).ready(function ($) {
  class Accordion {
    constructor(accordion) {
      this.bottomPadding = 15;
      this.$accordion = $(accordion);
      this.$container = this.$accordion.find(".luther-accordion-container");
      this.$containerTitle = this.$container.find(
        ".luther-accordion-container__title"
      );

      this.$containerTitle.on("click", this._handleTitleClick.bind(this));

      $(window).on("resize", this._handleResize.bind(this));

      this._handleFirstContainerOpen();
    }

    _handleFirstContainerOpen() {
      if (this.$accordion.hasClass("start-first-open")) {
        var $firstContainer = this.$container.first();
        var $content = $firstContainer.find(
          ".luther-accordion-container__content"
        );
        this._openContainer($firstContainer);
      }
    }

    _handleResize() {
      this.$container.each((i, container) => {
        var $container = $(container);
        if ($container.hasClass("open")) {
          var $content = $container.find(
            ".luther-accordion-container__content"
          );
          var height = $content.find(".content-inner").prop("scrollHeight");
          $content.css({ height: height + this.bottomPadding });
        }
      });
    }

    _handleTitleClick(e) {
      var $container = $(e.target).closest(".luther-accordion-container");

      if ($container.hasClass("open")) {
        this._closeContainer($container);
      } else {
        this._openContainer($container);
      }
      if (window.luther.YoutubeController) {
        window.luther.YoutubeController.resetAllVideos();
      }
    }

    _openContainer($container) {
      this._closeAllContainer();
      $container.addClass("open");
      var $content = $container.find(".luther-accordion-container__content");
      var height = $content.find(".content-inner").prop("scrollHeight");
      $content.css({ height: height + this.bottomPadding });
    }

    _closeContainer($container) {
      $container.removeClass("open");
      var $content = $container.find(".luther-accordion-container__content");
      $content.css({ height: 0 });
    }

    _closeAllContainer() {
      this.$container.each((i, el) => {
        this._closeContainer($(el));
      });
    }
  }

  window.luther = window.luther || {};
  window.luther.accordions = [];

  $(".wp-block-luther-accordion").each((i, el) => {
    let accordion = new Accordion(el);
    window.luther.accordions.push(accordion);
  });
});
